export default __webpack_public_path__ + "static/media/mail.d09129b4.svg";